<template>
  <div>
    <div class="simple-center" v-if="mode==='InputTel'">
      <h3>忘記密碼</h3><br>
      <b-button @click="backMerchantLogin">回登入頁</b-button><br><br>
      <h5>請聯繫業務提供綁定店家管理手機,否則日後忘記密碼只能通知業務重設</h5><br>
      <!--<h5>(子帳號忘記密碼請找店長重設)</h5><br>-->
      請輸入綁定之店家管理手機號碼：<br>
      <b-form-input type='text' v-model="searchTel" @keyup.enter="searchStoresByTel" class="col-6 mx-auto mt-2" placeholder="請輸入手機號碼"></b-form-input>
      <b-button class="mt-2" @click="searchStoresByTel">確認</b-button>
    </div>
    <div class="simple-center" v-if="mode==='StoreSelect'">
      <h3>綁定店家選擇</h3>
      <b-button class="my-2" @click="backTel">輸入其他手機號碼</b-button>
      <h5>(選擇店家點操作進下一步確認發送)</h5><br>
      <b-table
        :items="storeList"
        :fields="storeFields"
      >
        <template slot="status" slot-scope="row">
          {{row.item.requested?(row.item.recent_sent?'剛寄送':'可重新寄送'):'可寄送'}}
        </template>
        <template slot="actions" slot-scope="row">
          <b-button @click="selectStore(row.item)">
            操作
          </b-button
        ></template>
      </b-table>
    </div>
    <div class="simple-center" v-if="mode==='ConfirmSend'">
      <h3>寄送重設密碼簡訊</h3>
      <b-button class="mt-2" v-if="storeList.length===1" @click="backTel">重新輸入手機</b-button>
      <b-button class="mt-2" v-if="storeList.length>1" @click="backList">回列表</b-button>
      <b-form class="mt-2">
        <b-form-input class="col-md-4 mx-auto mt-2" type="text" disabled v-model="storeToSend.store_name"></b-form-input>
        <b-form-input class="col-md-4 mx-auto mt-2" type="text" disabled v-model="storeToSend.account_name"></b-form-input>
        <b-form-input class="col-md-4 mx-auto mt-2" type="text" disabled v-model="storeToSend.account"></b-form-input>
        <span class="col-md-4 mt-2"></span><b-button class="mt-2" @click="requestReset(storeToSend)">發送密碼重設簡訊</b-button><span class="col-md-4 mt-2"></span>
      </b-form>
    </div>
    <div class="simple-center" v-if="mode==='ConfirmReset'">
      <h3>確認密碼設定</h3>
      <b-form>
        <span>{{getRestTime(codeInfo.expire_time)}}</span>
        <b-form-input class="col-md-4 mx-auto mt-2" type="text" disabled v-model="codeInfo.account_name"></b-form-input>
        <b-form-input class="col-md-4 mx-auto mt-2" type="text" disabled v-model="codeInfo.account"></b-form-input>
        <b-form-input v-show="!showClearPwd" class="col-md-4 mx-auto mt-2" type="password" placeholder="輸入新密碼" v-model="newPwd"></b-form-input>
        <b-form-input v-show="!showClearPwd" class="col-md-4 mx-auto mt-2" type="password" placeholder="再輸入一次" v-model="confirmNewPwd"></b-form-input>
        <b-form-input v-show="showClearPwd" class="col-md-4 mx-auto mt-2" type="text" placeholder="輸入新密碼" v-model="newPwd"></b-form-input>
        <b-form-input v-show="showClearPwd" class="col-md-4 mx-auto mt-2" type="text" placeholder="再輸入一次" v-model="confirmNewPwd"></b-form-input>
        <b-form-checkbox v-model="showClearPwd">顯示密碼</b-form-checkbox>
        <span class="col-md-4 mt-2"></span><b-button class="mt-2" :disabled="tickExpired===true" @click="resetPwd">更新密碼</b-button><span class="col-md-4"></span>
      </b-form>
    </div>
    
  </div>
</template>

<script>

export default {
  name: 'ResetPwd',
  data: function () {
    return {
      mode:"InputTel", // InputTel/StoreSelect/ConfirmSend/ConfirmReset
      showClearPwd:false,
      searchTel:"",
      storeList:[],
      storeToSend: {},
      code:"",
      tickTime:null,
      tickExpired:false,
      codeInfo:{},
      newPwd:"",
      confirmNewPwd:"",
      storeFields:[
        {
          key:'store_name',
          label:'店家'
        },
        {
          key:'account_name',
          label:'帳號'
        },
        {
          key:'status',
          label:'狀態'
        },
        {
          key:'actions',
          label:'操作'
        }
      ],
    }
  },
  props: [

  ],
  methods: {
    backMerchantLogin() {
      // not working on server Q_Q
      //window.location.href="/adminplugin#merchant"
      //window.location.hash=""
      //remove the # without refresh page
      window.history.pushState("", document.title, window.location.pathname + window.location.search)
      window.history.go(0)
    },
    searchStoresByTel() {
      if (this.searchTel.length !== 10) {
        this.$bus.fnShowInfo('請輸入十碼的手機號碼')
        return
      }
      let Param = {
        'module':'get_resetpw_info',
        'method':this.searchTel,
        'useGet':true,
        'apiTarget':'rest'
      }
      this.$bus.apiCall(Param, function (data, vm) {
        if (data.ok === 0) {
            vm.$bus.fnShowInfo(data.msg)
            return
          }
        // 成功時無論如何都是已確認(由未設定變已設定 或已設定的更新)
        vm.storeList = data.data
        if (data.data.length === 1) {
          vm.storeToSend = data.data[0]
          vm.mode = 'ConfirmSend'
        }
        else if (data.data.length > 1) {
          vm.mode = 'StoreSelect'
        }
        else {
          //沒有資料
          vm.$bus.fnShowInfo(vm.searchTel+"沒有對應店家設定,店家負責人請連線業務人員")
        }
      }, this)
    },
    selectStore(store) {
      this.storeToSend = store
      this.mode = 'ConfirmSend'
    },
    backList() {
      this.mode = 'StoreSelect'
    },
    backTel() {
      this.mode = 'InputTel'
    },
    requestReset(info) {
      let Param = {
        'module':'request_reset',
        'method':info.spa_shop_id,
        'useGet':true,
        'apiTarget':'rest'
      }
      this.$bus.apiCall(Param, function (data, vm) {
        if (data.ok === 0) {
            vm.$bus.fnShowInfo(data.msg)
            return
          }
        vm.$bus.fnShowInfo("請收簡訊並由簡訊內的連結進行密碼設定操作")
      }, this)
    },
    resetPwd() {
      if (!this.newPwd || !this.confirmNewPwd) {
        this.$bus.fnShowInfo("密碼未填寫完成")
        return
      }
      if (this.newPwd !== this.confirmNewPwd) {
        this.$bus.fnShowInfo("兩次新密碼不一致")
        return
      }
      let Param = {
        'module':'merchant',
        'method':'resetAccountPwdByCode',
        merchant_account_id: this.codeInfo.merchant_account_id,
        code:this.code,
        password:this.newPwd
      }
      this.$bus.apiCall(Param, function (data, vm) {
        if (data.ok === 0) {
          vm.$bus.fnShowInfo(data.msg)
          return
        }
        this.$bus.hideMobileNavi = false
        vm.$bus.fnShowInfo("密碼設定完成請用新密碼登入")
        //redirect直接跳登入popup出來帶出帳號...?
        //window.open("http://localhost:8080/adminplugin#merchant?account="+vm.codeInfo.account)
        // 這個要deploy到spalogin一定要手動改的@_@
        window.open(window.location.protocol+"//"+window.location.host+window.location.pathname+"?account="+vm.codeInfo.account)
      }, this)
    },
    // 倒數計時待重構
    getRestTime(expire_time) {
      if (!expire_time || Date.parse(new Date(expire_time)) < this.tickTime ) {
        // 要去ticketList把對應in_negotiate_info清掉否則就不會更新隱藏
        if (expire_time) {
          this.tickExpired = true
        }
        return "憑證已過期"
      }
      const msec = Date.parse(new Date(expire_time)) - this.tickTime
      let min = parseInt(msec / 1000 / 60 % 60)
      let sec = parseInt(msec / 1000 % 60)
      return "剩餘:"+min+"分"+sec+"秒"
    },
    updateCount() {
      const that = this
      this.tickTime = Date.parse(new Date())
      setTimeout(function () {
        if (this.tickExpired !== true) {
          that.updateCount()
        }
      }, 1000)
    },
  },
  mounted() {
    this.tickExpired = false
    this.$bus.hideMobileNavi = true
    let code = this.getQueryVariable('code')
    if (code) {
      this.code = code
      window.location.hash = "#merchantreset"
      // 把query parameter清除掉
      this.mode = 'ConfirmReset'
      // 先用code抓取帳號數據
      let Param = {
        module: 'reset_code',
        method: code,
        apiTarget:'rest',
        useGet:true
      }
      this.$bus.apiCall(Param, function (data, vm) {
        if (data.ok === 0) {
            vm.$bus.fnShowInfo(data.msg)
            vm.tickExpired = true
            return
          }
        // 成功時無論如何都是已確認(由未設定變已設定 或已設定的更新)
        vm.codeInfo = data.data
        vm.updateCount()
      }, this)
    }
    else {
      this.mode = 'InputTel'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.simple-center {
  display:table-cell;
  width:100vw;
  height:70vh;
  vertical-align: middle;
}
</style>
